export const AdTag = () => {
  return (
    <svg
      width="28"
      height="16"
      viewBox="0 0 28 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="16" rx="8" fill="black" fillOpacity="0.5" />
      <path
        d="M6.24217 12L9.03514 4.22266H10.4048L13.2031 12H11.9409L9.74949 5.646H9.68504L7.48826 12H6.24217ZM11.7368 8.95459V9.94287H7.69773V8.95459H11.7368ZM15.2783 12V10.9634H17.1367C17.724 10.9634 18.2127 10.8524 18.603 10.6304C18.9933 10.4084 19.2852 10.0861 19.4785 9.66357C19.6755 9.23747 19.7739 8.71647 19.7739 8.10059C19.7739 7.49186 19.6772 6.97624 19.4839 6.55371C19.2941 6.1276 19.0076 5.80534 18.6245 5.58691C18.245 5.36849 17.7723 5.25928 17.2065 5.25928H15.2354V4.22266H17.2764C18.0391 4.22266 18.6943 4.37663 19.2422 4.68457C19.7936 4.99251 20.2144 5.43831 20.5044 6.02197C20.798 6.60563 20.9448 7.2985 20.9448 8.10059C20.9448 8.90983 20.7962 9.60628 20.499 10.1899C20.2054 10.7736 19.7775 11.2212 19.2153 11.5327C18.6567 11.8442 17.9871 12 17.2065 12H15.2783ZM15.8638 12H14.6821V4.22266H15.8638V12Z"
        fill="white"
      />
    </svg>
  );
};
